<cac-dialog-layout
  [title]="data.attribute ? 'Edit Attribute' : 'Add New Attribute'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
  [hideControls]="currentTabIndex() > 0"
>
  <cac-tabs>
    <cac-tab label="Attribute">
      <div class="p-6">
        <cac-form-builder [options]="attributeForm"></cac-form-builder>
      </div>
    </cac-tab>
    <cac-tab label="Values">
      <div class="space-y-4 pt-4">
        <div class="pt-4 ml-auto w-44">
          <cac-button (click)="createTermForm()">Add New Value</cac-button>
        </div>

        @for (term of terms(); let i = $index; track term) {
          <div #Term class="bg-white rounded-lg shadow-md border rounded-1 border-tertiary-200 overflow-hidden">
            <button
              (click)="toggleTerm(i)"
              class="w-full flex justify-between items-center p-4 cursor-pointer  hover:bg-tertiary-50 transition-colors"
              [class.border-b]="termIsExpanded[i]">
              <div class="flex items-center gap-2">
                <mat-icon
                  class="transition-transform duration-200"
                  [class.rotate-90]="termIsExpanded[i]"
                  [svgIcon]="'chevron-right'"
                />
                <h3 class="text-lg font-medium text-tertiary-800">
                  {{ (term.form.controls.englishName.value$ | async) ?? 'New Value' }}
                </h3>
              </div>

              <cac-button
                icon="trash"
                appearance="stroked"
                (click)="$event.stopPropagation(); deleteTerm(i)"
              />
            </button>

            <div
              *ngIf="termIsExpanded[i]"
              class="p-4 bg-white">
              <div class="p-3">
                <cac-form-builder [options]="term.form" />
              </div>
            </div>
          </div>
        }
      </div>

      <div class="pt-4" *ngIf="terms().length > 2">
        <cac-button (click)="createTermForm()">Add New Value</cac-button>
      </div>
    </cac-tab>
  </cac-tabs>
</cac-dialog-layout>
